@switch (mode()) {
  @case ('step1') {
    @defer {
      <app-step2-simple (complete)="next()" [discount]="discount()" [isCasual]="false" hasNextStep hideDatePart [completeUrl]="completeUrl()">
        <slot name="submit-button" slot="submit-button"></slot>
      </app-step2-simple>
    }
  }
  @case ('step2') {
    @defer {
      <app-step1 (selectDate)="complete()" hasComplete [isCasual]="false" discount="10" [isColorful]="isColorful()"></app-step1>
    }
  }
}
